<template>
  <!-- 右侧功能区 -->
  <div>
    <!-- <div class="functional">
      <el-table
        :data="subjectsTotal.tableData"
        :row-key="getRowKeys"
        style="width: 100%"
        height="605"
      >
        <el-table-column label="题号" width="160" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              placement="top-start"
              v-if="
                (scope.row.th &&
                  scope.row.th.length + scope.row.name &&
                  scope.row.name.length) > 10
              "
            >
              <div slot="content">{{ scope.row.th }}、{{ scope.row.name }}</div>
              <span
                >{{ scope.row.th }}{{ scope.row.start
                }}{{
                  scope.row.end
                    ? scope.row.start == scope.row.end
                      ? ""
                      : `-${scope.row.end}`
                    : scope.row.end
                }}、{{ scope.row.name.slice(0, 6) }}...</span
              >
            </el-tooltip>
            <span v-else
              >{{ scope.row.th }}{{ scope.row.start
              }}{{
                scope.row.end
                  ? scope.row.start == scope.row.end
                    ? ""
                    : `-${scope.row.end}`
                  : scope.row.end
              }}、{{ scope.row.name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="v2" label="题型" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 2">选择题</span>
            <span v-if="scope.row.type == 1">填空题</span>
            <span v-if="scope.row.type == 3">解答题</span>
            <span v-if="scope.row.type == 4">作文（英）</span>
            <span v-if="scope.row.type == 5">作文（语）</span>
            <span v-if="scope.row.type == 6">选做题</span>
          </template>
        </el-table-column>
        <el-table-column label="分值" width="70" align="center">
          <template slot-scope="scope">{{
            parseInt(scope.row.totalScore) == scope.row.totalScore
              ? scope.row.totalScore
              : String(scope.row.totalScore.toFixed(2)).split(".")[1] == "00"
              ? String(scope.row.totalScore.toFixed(2)).split(".")[0]
              : scope.row.totalScore.toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <span
              style="
                font-size: 20px;
                display: inline-block;
                color: #409eff;
                cursor: pointer;
                margin-right: 5px;
              "
              class="el-icon-edit"
              @click="worEdit(scope)"
            >
            </span>
            <span
              style="
                font-size: 20px;
                display: inline-block;
                color: red;
                cursor: pointer;
              "
              class="el-icon-delete"
              @click="worDel(scope)"
            ></span>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <objective-box v-show="objectiveDV" :isShow.sync="objectiveDV" :isEdit="isEdit" :allIndex="allIndex" />
    <fill-box v-show="fillDV" :isShow.sync="fillDV" :isEdit="isEdit" :allIndex="allIndex" />
    <answer-box v-show="answerDV" :isShow.sync="answerDV" :isEdit="isEdit" :allIndex="allIndex" />
    <choose-box v-show="chooseDV" :isShow.sync="chooseDV" :isEdit="isEdit" :allIndex="allIndex" />
    <writing-en-box v-show="writingEnDV" :isShow.sync="writingEnDV" :isEdit="isEdit" :allIndex="allIndex" />
    <writing-box v-show="writingDV" :isShow.sync="writingDV" :isEdit="isEdit" :allIndex="allIndex" />
    <!-- <blank-modal @submit-blank="submitBlank" v-model="fillBlankVisible" :type="'填空题'" /> -->
    <writing-box v-show="writingDV" :isShow.sync="writingDV" :isEdit="isEdit" :allIndex="allIndex" />
    <subject-blank @submit-blank="submitBlank2" v-model="fillBlankVisible2" :type="'填空题'" :subject="updateSubject" />
    <subject-objective v-model="objectiveVisible" type="选择题" :subject="updateSubject"
      @submit-objective="submitObjective" />
    <subject-answer v-model="answerVisible" type="解答题" @submit-answer="submitAnswer" :subject="updateSubject" />
    <subject-write-en v-model="writeEnVisible" :subject="updateSubject" type="英语作文" @submit-write="submitWriteEn" />
    <subject-write v-model="writeVisible" :subject="updateSubject" type="语文作文" @submit-write="submitWrite" />
    <subject-choose v-model="chooseVisible" :subject="updateSubject" type="选做题"
      @submit-choose="submitChoose"></subject-choose>
    <subject-nonAnswer v-model="nonAnswerVisible" :subject="updateSubject" type="非作答区域"
      @submit-nonAnswer="submitNonAnswer"></subject-nonAnswer>  
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
  import objectiveBox from "@/components/TopicMakeBox/ObjectiveBox";
  import fillBox from "@/components/TopicMakeBox/FillBox";
  import answerBox from "@/components/TopicMakeBox/AnswerBox";
  import chooseBox from "@/components/TopicMakeBox/ChooseBox";
  import writingEnBox from "@/components/TopicMakeBox/WritingEnBox";
  import writingBox from "@/components/TopicMakeBox/WritingBox";

  /* 引入新组件 */

  import SubjectBlank from "@/subjects/blank/Blank";
  import SubjectObjective from "@/subjects/objective/Objective";
  import SubjectAnswer from "@/subjects/answer/Answer";
  import SubjectWriteEn from "@/subjects/writeEn/WriteEn";
  import SubjectWrite from "@/subjects/write/Write";
  import subjectNonAnswer from "@/subjects/nonAnswerArea/nonAnswerArea";
  // import BlankModal from "@/subjects/blank/Blank.modal";
  import SubjectChoose from "@/subjects/choose/Choose";
  import subjects from "@/store/modules/subjects";

  import { toogleScore, setObjectiveHeight, getChinese } from "@/utils/common";
  import { ObjectiveModel } from "@/subjects/objective/Objective.model";
  import { BlankModel } from "@/subjects/blank/Blank.model";
  export default {
    name: "Functional",
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      objectiveBox,
      fillBox,
      answerBox,
      chooseBox,
      writingEnBox,
      writingBox,
      // 新组件
      SubjectBlank,
      SubjectObjective,
      SubjectAnswer,
      SubjectWriteEn,
      SubjectWrite,
      // BlankModal,
      SubjectChoose,
      subjectNonAnswer,
    },
    computed: {
      ...mapGetters({
        answerSheet: "answerPanel/answerSheet",
        visibleDialog: "answerPanel/visibleDialog",
        visibleDialogIndex: "answerPanel/visibleDialogIndex",
      }),
      ...mapState("card", {
        subjects: (state) => state.subjects,
        pageCell: (state) => state.pageCell,
      }),
      ...mapState("cardMake", [
        "topicStoreroom",
        "cardLoading",
        "objectiveDV",
        "fillDV",
        "answerDV",
        "chooseDV",
        "writingEnDV",
        "writingDV",
        "allIndex",
      ]), ////答卷设置参数

      maxCardExamNumberComputed() {
        let maxCardExamNumber = 18;
        if (this.answerSheet.acCardStudentCodeType === 0) {
          maxCardExamNumber = 14;
          if (this.answerSheet.acCardPanes == 3) {
            maxCardExamNumber = 12;
          }
        }
        if (
          this.answerSheet.acCardStudentCodeType === 1 &&
          this.answerSheet.acCardPanes == 3
        ) {
          maxCardExamNumber = 9;
        }
        return maxCardExamNumber;
      },
      worList() {
        let list = [];
        this.topicStoreroom.forEach((topic, topicIndex) => {
          if (topic && topic.typesItem) {
            list.push(topic);
          }
        });

        return list;
      },
      subjectsTotal() {
        let num = 0;
        let score = 0;
        const obj = {};
        this.subjects.length &&
          this.subjects.forEach((subject) => {
            score += Number(subject.totalScore || 0);
            subject.items &&
              subject.items.forEach(() => {
                num += 1;
              });
          });
        obj.subjectsTotalScore = score;
        obj.subjectsTotalNum = num;
        obj.tableData = JSON.parse(JSON.stringify(this.subjects)) || [];
        return obj;
      },
      getChinsesCardName() {
        return getChinese(this.answerSheet.acCardName);
      },
    },
    data() {
      return {
        dialogVisible: false,
        cacheAcCardPanes: 0,
        updateSubject: undefined,
        updateSubjectIdx: 0,
        subjectsTotalScore: 0,
        subjectsTotalNum: 0,
        isEdit: false,
        //allIndex: null,
        localityAnswerSheet: {
          acCardName: "答题卡",
          acCardPanes: "1", //布局：1、一栏，2、二栏，3三栏
          acCardYJType: 1, //评阅方式：1、手批，2网阅
          acCardStudentCodeType: 0, //考号填写模式：0-填涂考号， 1-条码 ，2-手写考号
          acCardExamNumber: 8, //考号位数
          acCardMissSign: true, //缺考标记：显示-true，隐藏-false
          acCardHideScore: false, //隐藏分值：显示-true，隐藏-false
          acCardPint: 2, //单面打印：1-单面  2-双面
          acCardABSet: false, //AB卷：开启-true，关闭-false
          acRedCard: false, // 是否红色答题卡
          acCardHideOrCode: true,
        },
        oldAnswerSheet: [1],
        tabsName: "first",
        ABModel: true,
        ABList: [
          {
            qid: "01",
            ans: "A",
          },
          {
            qid: "02",
            ans: "A",
          },
          {
            qid: "01",
            ans: "A",
          },
          {
            qid: "02",
            ans: "A",
          },
          {
            qid: "01",
            ans: "A",
          },
          {
            qid: "02",
            ans: "A",
          },
        ],

        // 新弹窗显示或隐藏
        fillBlankVisible: false,
        fillBlankVisible2: false,
        objectiveVisible: false,
        answerVisible: false,
        writeEnVisible: false,
        writeVisible: false,
        chooseVisible: false,
        nonAnswerVisible: false,
        writeModel: undefined,
        visibleMap: {
          //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题, 7 非作答区域
          1: "fillBlankVisible2",
          2: "objectiveVisible",
          3: "answerVisible",
          4: "writeEnVisible",
          5: "writeVisible",
          6: "chooseVisible",
          7: "nonAnswerVisible",
        },
        acCardName: "",
        myAcCardPint: false,
      };
    },
    acCardABSetChange(v) {
      this.answerSheetMut({ acCardABSet: v });
    },
    methods: {
      ...mapActions({
        answerSheetAction: "answerPanel/answerSheetAction",
        toogleScore: "answerPanel/toogleScore",
        setVisibleDialog: "answerPanel/setVisibleDialog",
      }),
      ...mapMutations({
        updatePageCellByHurdle: "card/updatePageCellByHurdle",
        changePageWidthByHurlde: "card/changePageWidthByHurlde",
        objectiveFromMut: "cardMake/objectiveFromMut",
        objectiveDVMut: "cardMake/objectiveDVMut",
        fillDVMut: "cardMake/fillDVMut",
        answerDVMut: "cardMake/answerDVMut",
        chooseDVMut: "cardMake/chooseDVMut",
        writingEnDVMut: "cardMake/writingEnDVMut",
        writingDVMut: "cardMake/writingDVMut",
        isBoxEditMut: "cardMake/isBoxEditMut",
        allIndexMut: "cardMake/allIndexMut",
        addSubject: "card/addSubject",
        // append: "subjects/append",
        append: "card/append",
        resetPageCell: "card/resetPageCell",
        deleteSubject: "card/deleteSubject",
        updateSubjects: "card/updateSubjects",
        sortSubjectByIndex: "card/sortSubjectByIndex",
      }), //参数的变动
      cha() {
        console.log(this.answerSheet, "111");
      },
      open(data) {
        this.functionType = data.functionType;
        this.openNewDialog(data.functionType);
      },
      acCardABSetChange(v) {
        this.answerSheetAction({ acCardABSet: v });
      },
      acRedCardChange(v) {
        this.answerSheetAction({ acRedCard: v });
      },
      acCardPintChange(v) {
        // console.log(v);
        this.$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let acCardPint = 2;
            //单面打印：1-单面  2-双面 默认双面
            if (v) {
              acCardPint = 1;
            }
            this.answerSheetAction({ acCardPint: acCardPint });
            this.resetPageCell({
              acCardPanes: this.answerSheet.acCardPanes,
              hurdleReset: true,
            });
          })
          .catch(() => {
            this.myAcCardPint = !v;
          });
      },
      cardHideScoreChange(v) {
        this.toogleScore(v);
        // /this.answerSheetAction({ acCardHideScore: v });
        //隐藏分值
      },
      cardYJTypeChange(v) {
        console.log("=======cardYJTypeChange===")
        this.$confirm("改变后会影响页面布局以及题型选项，确定改变吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          this.answerSheetAction({ acCardYJType: v });
          this.subjects.forEach((subject, index) => {
            if (subject.type == 1) {
              // 只有手批的时候 才有小题给分 网阅没有
              // acCardYJType 1 网阅 0 手批 2 手批
              subject.eachBlankScore = v == 0 ? true : false;
              this.updateSubjectsByindex(subject);
            }
          });
        });
      },
      cardNameChange(v) {
        this.answerSheetAction({ acCardName: v });
      },
      tabHandle(tab) { },
      openDialogByType(subject, index) {
        this[this.visibleMap[subject.type]] = true;
        this.updateSubject = subject;
        this.updateSubjectIdx = index;
      },
      openNewDialog(type) {
        this[this.visibleMap[type]] = true;
        this.updateSubject = undefined;
      },
      worEdit(scop) {
        const { $index } = scop;
        const subject = this.subjects[$index];
        this.openDialogByType(subject, $index);
        // this.isEdit = true;
        // this.objectiveDV = true;
      },
      worDel(scop) {
        this.$confirm("删除后会影响试题布局，确定删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async (item) => {
            const { $index } = scop;
            await this.deleteSubject($index); // 通过下标删除指定元素
            await this.resetPageCell({
              acCardPanes: this.answerSheet.acCardPanes,
              index: $index - 1 < 0 ? 0 : $index - 1,
              byDel: true,
            });
          })
          .catch(() => {
            console.log("取消删除");
          });
      },
      ABModelhandle(v) { },

      changeCardStudentCode(acCardPanes) {
        if (
          acCardPanes == 3 &&
          this.answerSheet.acCardStudentCodeType === 0 &&
          this.answerSheet.acCardExamNumber >= 9
        ) {
          // 三栏
          this.answerSheetAction({ acCardExamNumber: 9 });
        }
        if (
          acCardPanes != 3 &&
          this.answerSheet.acCardStudentCodeType === 0 &&
          this.answerSheet.acCardExamNumber >= 14
        ) {
          // 三栏
          this.answerSheetAction({ acCardExamNumber: 14 });
        }
      },

      hurdleChange(val) {
        this.$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.cacheAcCardPanes = val;
            this.answerSheetAction({ acCardPanes: val });
            this.changeCardStudentCode(val);
            // this.changePageWidthByHurlde({ acCardPanes: val });
            // this.resetPageCell(val);
            this.subjects.forEach(async (subject, index) => {
              if (subject.type == 2) {
                // 这里确保一张答题卡最好只有一种题型是选择题 这样循环指挥执行一次 resetpagecell 渲染页面
                // 将客观题横竖排的rowList更新 这里的subject里面需要newData.diffLayout
                subject = await setObjectiveHeight(subject, subject);
                this.updateSubjects({
                  index: index,
                  data: new ObjectiveModel(subject),
                });
                this.resetPageCell({
                  acCardPanes: val,
                  hurdleReset: true,
                });
              }
            });

            this.resetPageCell({
              acCardPanes: val,
              hurdleReset: true,
            });
            // this.updatePageCellByHurdle({});
            // this.writeModel.render();
            // render之后对象属性已经更新 需要把store里面的数据重新更新
            // 可以将所有题型都重新写入一个方法叫做updateDataByHurdle
            this.oldAnswerSheet[0] = val;
            let pageData = {
              isDefault: true, //是否切换栏数了
            };
            // cardOperate.operatePageCell(pageData).then((data) => {
            //   this.localityAnswerSheet = JSON.parse(
            //     JSON.stringify(this.answerSheet)
            //   );
            // });
          })
          .catch(() => {
            this.answerSheetAction({ acCardPanes: this.cacheAcCardPanes });
            // this.localityAnswerSheet.acCardPanes = this.oldAnswerSheet[0];
          });
      }, //改变栏数
      examNumInfo(v) {
        this.answerSheetAction({ acCardStudentCodeType: v });
        let pageData = {
          isDefault: false, //是否切换栏数了
        };
        this.changeCardStudentCode();
        // this.resetPageCell({
        //   acCardPanes: this.answerSheet.acCardPanes,
        // });
      }, //改变考号信息方式
      codeNumChange(val) {
        // 改变考号位数
        this.answerSheetAction({ acCardExamNumber: val });
        // this.resetPageCell(this.answerSheet.acCardPanes);
        // this.resetPageCell({
        //   acCardPanes: this.answerSheet.acCardPanes,
        // });

        // cardOperate.operatePageCell();
      },
      absentChange(v) {
        this.answerSheetAction({ acCardMissSign: v });
      }, //缺考标记改变

      //添加修添加题型
      async updateSubjectsByindex(updateSubject) {
        const index = this.updateSubjectIdx;
        console.log('updateSubjectsByindex===============', updateSubject);
        // 这里的编辑更新肯定需要更改题型的html和高度 不可能保存之前的数据
        updateSubject.setFromEdit(true);
        await this.updateSubjects({
          index: index,
          data: updateSubject,
        });
        await this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          index: index,
        });
        if (updateSubject.type != 2) {
          return;
        }
        // 这样写是为了 dom更新之后 处理选择题 精确计算选择题的高度
        updateSubject = await setObjectiveHeight(updateSubject);
        await this.updateSubjects({
          index: index,
          data: new ObjectiveModel(updateSubject),
        });
        await this.resetPageCell({
          acCardPanes: this.answerSheet.acCardPanes,
          index: index,
        });
      },
      submitBlank(data) {
        if (data) {
          // this.addSubject(data);
          this.fillBlankVisible = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitBlank2(data) {
        if (data) {
          this.fillBlankVisible2 = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
        // this.append(new BlankModel())
      },
      submitObjective(data) {
        if (data) {
          this.objectiveVisible = false;
          let hasObjective = this.subjects.find(item => item.type == 2);
          let acCardAutoMerge = this.answerSheet.acCardAutoMerge
          // 自动合并客观题
          if (acCardAutoMerge && hasObjective && !this.updateSubject) {
            this.updateSubject = true;
            let { end, start } = hasObjective
            data.start = start
            data.end = start + hasObjective.items.length + data.items.length
            data.items = hasObjective.items.concat(data.items)
          }
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitAnswer(data) {
        console.log('submitAnswer submitAnswer', data);
        if (data) {
          this.answerVisible = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitWriteEn(data) {
        if (data) {
          // this.addSubject(data);
          this.writeEnVisible = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitWrite(data) {
        if (data) {
          // this.addSubject(data);
          this.writeVisible = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitChoose(data) {
        if (data) {
          console.log('submitChoose submitChoose::::', data);
          this.chooseVisible = false;
          this.updateSubject
            ? this.updateSubjectsByindex(data)
            : this.append(data);
        }
      },
      submitNonAnswer(data) {
        console.log('submitNonAnswer submitNonAnswer', data);
        if (data) {
          this.nonAnswerVisible = false;
          this.append(data)
        }
      },
      getRowKeys(row) {
        return row.id;
      },
      //行拖拽
      rowDrop() {
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        const _this = this;
        Sortable.create(tbody, {
          onEnd({ newIndex, oldIndex }) {
            const currRow = _this.subjectsTotal.tableData.splice(oldIndex, 1)[0];
            _this.subjectsTotal.tableData.splice(newIndex, 0, currRow);
            _this
              .$confirm("修改后自定义编辑的内容会消失，确定修改吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                _this.sortSubjectByIndex({ newIndex, oldIndex });
                _this.resetPageCell({
                  acCardPanes: _this.answerSheet.acCardPanes,
                  hurdleReset: true,
                });
              })
              .catch(() => {
                const currRow = _this.subjectsTotal.tableData.splice(
                  newIndex,
                  1
                )[0];
                _this.subjectsTotal.tableData.splice(oldIndex, 0, currRow);
              });
          },
        });
      },
    },
    watch: {
      visibleDialog(val) {
        this[val] = true;
        this.setVisibleDialog(null);
        this.updateSubject = this.subjects[this.visibleDialogIndex];
        this.updateSubjectIdx = this.visibleDialogIndex; // this.updateSubject = subject;
      },
      // functionType(val) {
      //   this.openNewDialog(val);
      // },
      visible(val) {
        this.dialogVisible = val;
      },
    },
    mounted() {
      const timer = setTimeout(() => {
        this.cacheAcCardPanes = this.answerSheet.acCardPanes;
        this.rowDrop();
        clearTimeout(timer);
      }, 500);
    },
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .functional {
    .el-divider--horizontal {
      margin: 24px 0 0 0 !important;
    }

    .el-tabs .el-tabs__nav {
      left: calc(50% - 130px);
    }

    .el-tabs__nav {
      width: 90%;
      margin: 0 5%;
    }

    .el-tabs__item {
      width: 30%;
      text-align: center;
      padding: 0;
      height: 52px;
      line-height: 52px;
    }

    .el-tabs__header {
      margin: 0;
    }

    .el-input__inner {
      font-size: 18px;
      border-left: 0;
      border-right: 0;
      border-top: 0;
      border-radius: 0;
    }

    .tab-item {
      padding: 0 20px;

      .t-item-name {
        padding-top: 40px;
        color: #999;
      }

      .t-item {
        padding-top: 10px;
      }

      .el-select {
        width: 100%;
      }

      .el-input--suffix .el-input__inner {
        padding-left: 5px;
        font-size: 12px;
      }

      .el-input__suffix .el-icon-arrow-up:before {
        content: "\e78f";
        color: #4891ff;
        font-size: 20px;
      }

      .el-input-number .el-input__inner {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }

      .el-checkbox__label {
        font-size: 12px;
      }
    }

    .custom-row {
      margin-top: 20px;
      display: flex;

      &.divide {
        margin-bottom: 20px;

        .custom-col {
          width: 50%;

          &:nth-child(2) {
            text-align: right;
          }
        }
      }
    }

    .btn {
      .el-button {
        width: 112px;
        margin: 20px 5px 0;
      }
    }

    .score-hd {
      padding: 30px 0 30px 20px;
      font-size: 14px;
    }

    .el-table th {
      background: #f5f7fa;
    }

    .ab-model-btn {
      text-align: center;
    }

    .ab-model {
      padding: 0 10px;

      .custom-row {
        flex-wrap: wrap;
      }

      .custom-col {
        width: 60px;
        margin-left: 20px;
        margin-bottom: 20px;
      }

      .nothing {
        padding-top: 30%;
        text-align: center;
      }
    }
  }
</style>